"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsightDimensionTypeToJSON = exports.InsightDimensionTypeFromJSONTyped = exports.InsightDimensionTypeFromJSON = exports.InsightDimensionType = void 0;
/**
 * InsightDimensionType describes the "second-level" insight that a particular report request
 * is interested in. For example, passing the PLATFORM parameter in a request will generate
 * a LIFETIME report of all requested metrics across IOS, ANDROID, and WEB.
 *
 * @export
 */
exports.InsightDimensionType = {
    Age: 'AGE',
    Country: 'COUNTRY',
    Gender: 'GENDER',
    Genre: 'GENRE',
    Platform: 'PLATFORM'
};
function InsightDimensionTypeFromJSON(json) {
    return InsightDimensionTypeFromJSONTyped(json, false);
}
exports.InsightDimensionTypeFromJSON = InsightDimensionTypeFromJSON;
function InsightDimensionTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.InsightDimensionTypeFromJSONTyped = InsightDimensionTypeFromJSONTyped;
function InsightDimensionTypeToJSON(value) {
    return value;
}
exports.InsightDimensionTypeToJSON = InsightDimensionTypeToJSON;
